import deepmerge from 'deepmerge'
import { Reducer } from 'redux'
import { CartState } from 'types/redux'

import {
  ADD_VOUCHER_ERROR,
  ADD_VOUCHER_REQUEST,
  ADD_VOUCHER_SUCCESS,
  RESET_VOUCHER_SUCCESS,
  RESET_VOUCHER_ERROR,
  SET_COLLECTIVE_ORDER,
  UPDATE_CART_SUCCESS,
  UPDATE_REDPOINTS_REQUEST,
  UPDATE_REDPOINTS_SUCCESS,
  UPDATE_CART_VOUCHER_ERROR
} from './types.consts'
import { CartActionTypes } from './actions'
import preloadedCartState from './preloadedState'

// REDUCER: modify state according to dispatched actions
// eslint-disable-next-line complexity
const reducer: Reducer<CartState> = (
  state: CartState = preloadedCartState,
  action: CartActionTypes
): CartState => {
  switch (action.type) {
    case UPDATE_CART_SUCCESS:
      return {
        ...state,
        data: action.payload
      }
    case SET_COLLECTIVE_ORDER:
      return {
        ...state,
        collectiveOrder: action.payload
      }
    case ADD_VOUCHER_REQUEST:
      return deepmerge(state, {
        voucherLoad: true
      })
    case ADD_VOUCHER_SUCCESS:
      return deepmerge(state, {
        voucherLoad: false,
        voucherAccepted: true,
        voucherError: null
      })
    case ADD_VOUCHER_ERROR:
      return deepmerge(state, {
        voucherLoad: false
      })
    case RESET_VOUCHER_SUCCESS:
      return deepmerge(state, {
        voucherAccepted: false
      })
    case RESET_VOUCHER_ERROR:
      return deepmerge(state, {
        voucherLoad: false,
        voucherError: null
      })
    case UPDATE_REDPOINTS_REQUEST:
      return deepmerge(state, {
        redPointsLoad: true,
        redPointsAccepted: false
      })
    case UPDATE_CART_VOUCHER_ERROR:
      return deepmerge(state, {
        voucherError: action.payload
      })
    case UPDATE_REDPOINTS_SUCCESS:
      return deepmerge(state, {
        redPointsLoad: false,
        redPointsAccepted: true
      })
    default:
      return state
  }
}
export default reducer
